module.exports = __webpack_public_path__ + "static/fibra-de-vidrio-b4608f1c844fade8f88f0c8895fad14f.jpg";